import { BackgroundWrapper } from './DetailsBackgroundWrapper.styled'

const DetailsBackgroundWrapper: React.FC = ({ children }) => {
  return <BackgroundWrapper>{children}</BackgroundWrapper>
}

export default DetailsBackgroundWrapper
